module.exports = __webpack_public_path__ + "static/annotate-2bcd5a821bc5c4f6002bc2f1b2eb48b8.mp4";